import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
  Paper,
} from "@mui/material";

import store from "../../store";
import { Header, MainColorButton, Loading } from "../../components";
import { bottomButton } from "../../common/styles";
import { INTERVIEW_NOT_REGISTERED, PHARMACY_SELECTOR } from "../../routes/path";
import { ERROR, FAMILY_ADDER } from "../../routes/path";
import { getCustomerInfo } from "../../server/axios";
import {
  setCustomerSelected,
  setFamiliesData,
} from "../../store/actions/prescription";
import "./prescriptionStyle.css";

/**
 * 処方箋申込[利用者選択]
 * @returns
 */
const CustomerSelector = () => {
  const [endY, setEndY] = useState(0);
  const navigate = useNavigate();
  let location = useLocation();
  const [tblData, setTblData] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState();
  const [selectedUser, setSelectedUser] = useState([]);
  //Loadingコンポネント表示非表示state
  const [loadingOpen, setLoadingOpen] = useState(true);

  const handleClick = (index) => {
    let selectedRows = tblData[index];
    setSelectedUser(selectedRows);
    setSelectedIndex(index + 1);
    store.dispatch(
      setCustomerSelected({
        selectedRows,
      })
    );
  };

  const [data, setData] = useState({
    siteId: location.state?.siteId,
    customerId: location.state?.customerId || "",
    //姓
    lastName: location.state?.lastName || "",
    //名
    firstName: location.state?.firstName || "",
    //姓かな
    lastNameKana: location.state?.lastNameKana || "",
    //名かな
    firstNameKana: location.state?.firstNameKana || "",
    //性別
    gender: location.state?.gender || "",
    //生年月日
    birthday: location.state?.birthday || null,
    //減免フラグ
    exemptionFlg: location.state?.exemptionFlg || false,
    //郵便番号
    postalCode: location.state?.postalCode || "",
    //都道府県
    prefecture: location.state?.prefecture || "",
    //市区町村
    municipalities: location.state?.municipalities || "",
    //町名番地
    townNameAddress: location.state?.townNameAddress || "",
    //建物名等
    buildingNameEtc: location.state?.buildingNameEtc || "",
    //電話番号
    phoneNumber: location.state?.phoneNumber || "",
    //家族情報
    families: location.state?.families || [],
    //問診フラグ
    interviewFlg: location.state?.interviewFlg || false,
  });
  const getInitData = () => {
    setLoadingOpen(true);
    const selectLineInfo = (state) => state.prescription.lineInfo;
    let lineInfo = selectLineInfo(store.getState());
    getCustomerInfo({ lineId: lineInfo.lineId }).then((res) => {
      setData({
        siteId: res.data.siteId,
        customerId: res.data.customerId,
        updateDatetime: res.data.updateDatetime,
        lastName: res.data.lastName || "",
        firstName: res.data.firstName || "",
        lastNameKana: res.data.lastNameKana || "",
        firstNameKana: res.data.firstNameKana || "",
        gender: res.data.gender || "",
        birthday: res.data.birthday || null,
        exemptionFlg: res.data.exemptionFlg || false,
        postalCode: res.data.postalCode || "",
        prefecture: res.data.prefecture || "",
        municipalities: res.data.municipalities || "",
        townNameAddress: res.data.townNameAddress || "",
        buildingNameEtc: res.data.buildingNameEtc || "",
        phoneNumber: res.data.phoneNumber || "",
        families: res.data.families || [],
        interviewFlg: res.data.interviewFlg,
      });
      setLoadingOpen(false);
    });
  };

  // 初回render
  const firstRenderRef = useRef(0);

  useEffect(() => {
    if (firstRenderRef.current === 0) {
      getInitData();
    }
    firstRenderRef.current += 1;
  }, []);

  useEffect(() => {
    if (data) {
      const userList = [];
      let userName = `${data.lastName || ""}${data.firstName || ""}`;
      userList.push(
        createData(
          data.customerId,
          userName,
          0,
          "本人",
          data.interviewFlg || false,
          data.birthday,
          data.gender,
          data.exemptionFlg
        )
      );
      // 家族いる場合
      if (data.families) {
        data.families.forEach((family) => {
          const userName = `${family.lastName || ""}${
            family.firstName || ""
          } `;
          userList.push(
            createData(
              data.customerId,
              userName,
              family.familyId,
              family.relationshipClassText,
              family.interviewFlg || false,
              family.birthday,
              family.gender,
              family.exemptionFlg
            )
          );
        });
      }
      setTblData(userList);
    }
  }, [data]);

  useEffect(() => {
    if (
      (!location.state?.siteId && !data.siteId) ||
      (!location.state?.customerId && !data.customerId) ||
      (!location.state?.updateDatetime && !data.updateDatetime)
    ) {
      navigate(ERROR);
    }
    return () => {
      store.dispatch(setFamiliesData(data.families));
    };
  }, [selectedIndex]);

  const { siteId, customerId } = location.state;
  const createData = (
    customerId,
    name,
    familyId,
    relation,
    flag,
    birthday,
    gender,
    exemptionFlg
  ) => ({
    customerId,
    name,
    familyId,
    relation,
    flag,
    birthday,
    gender,
    exemptionFlg,
  });

  const addNewFamily = () => {
    const samePersonCheckArray = data.families.map((f) => ({
      lastName: f.lastName,
      firstName: f.firstName,
      birthday: f.birthday,
    }));
    samePersonCheckArray.push({
      lastName: data.lastName,
      firstName: data.firstName,
      birthday: data.birthday,
    });
    navigate(FAMILY_ADDER, {
      state: {
        customerId: data.customerId,
        siteId: data.siteId,
        samePersonCheckArray,
      },
    });
  };

  return (
    <>
      <Loading open={loadingOpen} />
      <div
        onTouchStartCapture={(e) => {
          setEndY(0);
        }}
        onTouchMoveCapture={(e) => {
          setEndY(e.touches[0].clientY);
        }}
        onTouchEndCapture={(e) => {
          if (endY !== 0) {
            e.stopPropagation();
          }
        }}
      >
        <Header title="処方箋申込[利用者選択]" />
        <Box
          sx={{ height: "76vh", overflowY: "scroll" }}
          marginTop="9vh"
          width="95%"
          marginLeft="auto"
          marginRight="auto"
        >
          <Stack>
            <Typography variant="subtitle1" align="left">
              利用者を選択してください。
            </Typography>
            <MainColorButton
              label="家族追加"
              onClick={addNewFamily}
              style={{ height: "4vh", marginBottom: "1vh" }}
            />
            <TableContainer
              component={Paper}
              elevation={0}
              variant="outlined"
              sx={{ width: "auto" }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <Typography>No</Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography>名前</Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography>続柄</Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography>問診</Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tblData.map((row, index) => (
                    <TableRow
                      key={index}
                      onClick={() => handleClick(index, row)}
                      sx={{
                        backgroundColor:
                          index + 1 === selectedIndex ? "#a7d59f" : undefined,
                      }}
                    >
                      <TableCell align="left">{index + 1}</TableCell>
                      <TableCell align="left">{row.name}</TableCell>
                      <TableCell align="center">{row.relation}</TableCell>
                      <TableCell align="center">
                        {row.flag ? "済" : "未"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Stack>
        </Box>
        <MainColorButton
          label="次へ"
          disabled={selectedIndex === undefined}
          onClick={() => {
            selectedUser.flag
              ? navigate(PHARMACY_SELECTOR, {
                  state: {
                    customerId: customerId || data.customerId,
                    siteId: siteId || data.siteId,
                  },
                })
              : navigate(INTERVIEW_NOT_REGISTERED, {
                  state: {
                    customerId: customerId || data.customerId,
                    siteId: siteId || data.siteId,
                    birthday: selectedUser.birthday,
                    gender: selectedUser.gender,
                    familyId: selectedUser.familyId,
                    name: selectedUser.name,
                  },
                });
          }}
          style={bottomButton}
        />
      </div>
    </>
  );
};

export default CustomerSelector;
